import React, { memo } from 'react';
import { MdVerifiedUser } from 'react-icons/md';
import { useIntl } from 'react-intl';

import './style.scss';

const VerificationBadge = memo(({ isVerified }) => {
  const intl = useIntl();

  if (!isVerified) {
    return null;
  }

  return (
    <span className="c-verification" role="img"
      aria-label={intl.formatMessage({ id: 'components.verification.verification-tooltip', defaultMessage: 'Verified' })}
      title={intl.formatMessage({ id: 'components.verification.verification-tooltip', defaultMessage: 'Verified' })}>
      <MdVerifiedUser aria-hidden="true" />
    </span>
  );
});

export default VerificationBadge;
